<template>
<div class="chapter">
<div class="inner_page">
<p class="chaptitle">CONTENTS<br/><br/></p>
<p class="ded"><a href="#/OEBPS/06preface.htm">PREFACE</a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/07ack.htm">ACKNOWLEDGMENTS</a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch01.htm">CHAPTER 1<br/>
<b>Introduction: An Eight-Hundred-Pound Gorilla</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/part1.htm"><b>part one. the cold war era</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch02.htm">CHAPTER 2<br/>
<b>An Alliance of Necessity: The Secret Friendship of the Shah</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch03.htm">CHAPTER 3<br/>
<b>Rise of Israel, Rise of Iran</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch04.htm">CHAPTER 4<br/>
<b>Iran's Quest for Supremacy</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch05.htm">CHAPTER 5<br/>
<b>Sealing Demise in the Moment of Triumph</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch06.htm">CHAPTER 6<br/>
<b>Megalomania</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch07.htm">CHAPTER 7<br/>
<b>The Rise of Begin and the Israeli Right</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch08.htm">CHAPTER 8<br/>
<b>Enter the Sign of God</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch09.htm">CHAPTER 9<br/>
<b>Ideological Shifts, Geopolitical Continuities</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch10.htm">CHAPTER 10<br/>
<b>Saddam Attacks!</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch11.htm">CHAPTER 11<br/>
<b>Scandal</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch12.htm">CHAPTER 12<br/>
<b>The Dying Gasp of the Periphery Doctrine</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/part2.htm"><b>part two. the unipolar era</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch13.htm">CHAPTER 13<br/>
<b>The New World Order</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch14.htm">CHAPTER 14<br/>
<b>Trading Enemies</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch15.htm">CHAPTER 15<br/>
<b>From Cold Peace to Cold War</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch16.htm">CHAPTER 16<br/>
<b>With Likud, the Periphery Doctrine Returns</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch17.htm">CHAPTER 17<br/>
<b>Khatami's Détente</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch18.htm">CHAPTER 18<br/>
<b>Betrayal in Afghanistan</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch19.htm">CHAPTER 19<br/>
<b>Snatching Defeat from the Jaws of Victory</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/part3.htm"><b>part three. looking ahead</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/ch20.htm">CHAPTER 20<br/>
<b>Facing the Future, Facing Reality</b></a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/note.htm">NOTES</a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/appa.htm">APPENDIX A: IRAN'S MAY 2003 NEGOTIATION PROPOSAL<br/>TO THE UNITED STATES</a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/appb.htm">APPENDIX B: ORIGINAL U.S. DRAFT NEGOTIATION PROPOSAL</a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/appc.htm">APPENDIX C: LETTER FROM AMBASSADOR GULDIMANN<br/>TO THE U.S. STATE DEPARTMENT</a><br/><br/></p>
<p class="ded"><a href="#/OEBPS/index.htm">INDEX</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05-contents.vue?898484a2